import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4df2509e = () => interopDefault(import('../pages/all-game.vue' /* webpackChunkName: "pages/all-game" */))
const _13415fde = () => interopDefault(import('../pages/customer.vue' /* webpackChunkName: "pages/customer" */))
const _41f207e1 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _09579ea7 = () => interopDefault(import('../pages/customer/question.vue' /* webpackChunkName: "pages/customer/question" */))
const _1aa64bea = () => interopDefault(import('../pages/customer/question/index.vue' /* webpackChunkName: "pages/customer/question/index" */))
const _4cec6ecf = () => interopDefault(import('../pages/customer/question/commit.vue' /* webpackChunkName: "pages/customer/question/commit" */))
const _0e1ef6ac = () => interopDefault(import('../pages/customer/question/history.vue' /* webpackChunkName: "pages/customer/question/history" */))
const _576b7e5c = () => interopDefault(import('../pages/customer/question/_id.vue' /* webpackChunkName: "pages/customer/question/_id" */))
const _49891e90 = () => interopDefault(import('../pages/game-maintenance.vue' /* webpackChunkName: "pages/game-maintenance" */))
const _600ba736 = () => interopDefault(import('../pages/gifts/index.vue' /* webpackChunkName: "pages/gifts/index" */))
const _b403dbce = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4d10f70b = () => interopDefault(import('../pages/maintain.vue' /* webpackChunkName: "pages/maintain" */))
const _63a7f580 = () => interopDefault(import('../pages/personal.vue' /* webpackChunkName: "pages/personal" */))
const _49af9bc3 = () => interopDefault(import('../pages/personal/index.vue' /* webpackChunkName: "pages/personal/index" */))
const _0dc353a4 = () => interopDefault(import('../pages/personal/my-game.vue' /* webpackChunkName: "pages/personal/my-game" */))
const _289551e1 = () => interopDefault(import('../pages/personal/my-reward.vue' /* webpackChunkName: "pages/personal/my-reward" */))
const _bd957216 = () => interopDefault(import('../pages/personal/pay-record.vue' /* webpackChunkName: "pages/personal/pay-record" */))
const _7269f7fd = () => interopDefault(import('../pages/personal/vip-info.vue' /* webpackChunkName: "pages/personal/vip-info" */))
const _5d73d227 = () => interopDefault(import('../pages/recharge.vue' /* webpackChunkName: "pages/recharge" */))
const _3aaddf6a = () => interopDefault(import('../pages/recharge/index.vue' /* webpackChunkName: "pages/recharge/index" */))
const _18b2ddd4 = () => interopDefault(import('../pages/recharge/bank.vue' /* webpackChunkName: "pages/recharge/bank" */))
const _de5c16b2 = () => interopDefault(import('../pages/rules.vue' /* webpackChunkName: "pages/rules" */))
const _a8fcef6c = () => interopDefault(import('../pages/vip-rights/index.vue' /* webpackChunkName: "pages/vip-rights/index" */))
const _04e772ed = () => interopDefault(import('../pages/vip-rights/growth-system.vue' /* webpackChunkName: "pages/vip-rights/growth-system" */))
const _0f9568e4 = () => interopDefault(import('../pages/vip-rights/intro.vue' /* webpackChunkName: "pages/vip-rights/intro" */))
const _04c0b467 = () => interopDefault(import('../pages/vip-rights/intro/index.vue' /* webpackChunkName: "pages/vip-rights/intro/index" */))
const _d61e4702 = () => interopDefault(import('../pages/vip-rights/intro/counpon.vue' /* webpackChunkName: "pages/vip-rights/intro/counpon" */))
const _0a2e20a0 = () => interopDefault(import('../pages/vip-rights/intro/first-pay.vue' /* webpackChunkName: "pages/vip-rights/intro/first-pay" */))
const _2e65f5d0 = () => interopDefault(import('../pages/vip-rights/intro/more.vue' /* webpackChunkName: "pages/vip-rights/intro/more" */))
const _1a8f4a6b = () => interopDefault(import('../pages/vip-rights/intro/vip-package.vue' /* webpackChunkName: "pages/vip-rights/intro/vip-package" */))
const _62d229c0 = () => interopDefault(import('../pages/wd-client/qr-pay.vue' /* webpackChunkName: "pages/wd-client/qr-pay" */))
const _475321fc = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _7f002db2 = () => interopDefault(import('../pages/game-offical/_game_id/index.vue' /* webpackChunkName: "pages/game-offical/_game_id/index" */))
const _4ff0ae17 = () => interopDefault(import('../pages/gifts/_gift_id.vue' /* webpackChunkName: "pages/gifts/_gift_id" */))
const _06a96f80 = () => interopDefault(import('../pages/game-offical/_game_id/gift.vue' /* webpackChunkName: "pages/game-offical/_game_id/gift" */))
const _4404ef84 = () => interopDefault(import('../pages/game-offical/_game_id/play.vue' /* webpackChunkName: "pages/game-offical/_game_id/play" */))
const _25a628c8 = () => interopDefault(import('../pages/game-offical/_game_id/server-list.vue' /* webpackChunkName: "pages/game-offical/_game_id/server-list" */))
const _aa1202c4 = () => interopDefault(import('../pages/game-offical/_game_id/server-list-update.vue' /* webpackChunkName: "pages/game-offical/_game_id/server-list-update" */))
const _470c56d5 = () => interopDefault(import('../pages/game-offical/_game_id/notice/list.vue' /* webpackChunkName: "pages/game-offical/_game_id/notice/list" */))
const _f7a4624c = () => interopDefault(import('../pages/game-offical/_game_id/notice/_notice_id.vue' /* webpackChunkName: "pages/game-offical/_game_id/notice/_notice_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/all-game",
    component: _4df2509e,
    name: "all-game"
  }, {
    path: "/customer",
    component: _13415fde,
    children: [{
      path: "",
      component: _41f207e1,
      name: "customer"
    }, {
      path: "question",
      component: _09579ea7,
      children: [{
        path: "",
        component: _1aa64bea,
        name: "customer-question"
      }, {
        path: "commit",
        component: _4cec6ecf,
        name: "customer-question-commit"
      }, {
        path: "history",
        component: _0e1ef6ac,
        name: "customer-question-history"
      }, {
        path: ":id",
        component: _576b7e5c,
        name: "customer-question-id"
      }]
    }]
  }, {
    path: "/game-maintenance",
    component: _49891e90,
    name: "game-maintenance"
  }, {
    path: "/gifts",
    component: _600ba736,
    name: "gifts"
  }, {
    path: "/login",
    component: _b403dbce,
    name: "login"
  }, {
    path: "/maintain",
    component: _4d10f70b,
    name: "maintain"
  }, {
    path: "/personal",
    component: _63a7f580,
    children: [{
      path: "",
      component: _49af9bc3,
      name: "personal"
    }, {
      path: "my-game",
      component: _0dc353a4,
      name: "personal-my-game"
    }, {
      path: "my-reward",
      component: _289551e1,
      name: "personal-my-reward"
    }, {
      path: "pay-record",
      component: _bd957216,
      name: "personal-pay-record"
    }, {
      path: "vip-info",
      component: _7269f7fd,
      name: "personal-vip-info"
    }]
  }, {
    path: "/recharge",
    component: _5d73d227,
    children: [{
      path: "",
      component: _3aaddf6a,
      name: "recharge"
    }, {
      path: "bank",
      component: _18b2ddd4,
      name: "recharge-bank"
    }]
  }, {
    path: "/rules",
    component: _de5c16b2,
    name: "rules"
  }, {
    path: "/vip-rights",
    component: _a8fcef6c,
    name: "vip-rights"
  }, {
    path: "/vip-rights/growth-system",
    component: _04e772ed,
    name: "vip-rights-growth-system"
  }, {
    path: "/vip-rights/intro",
    component: _0f9568e4,
    children: [{
      path: "",
      component: _04c0b467,
      name: "vip-rights-intro"
    }, {
      path: "counpon",
      component: _d61e4702,
      name: "vip-rights-intro-counpon"
    }, {
      path: "first-pay",
      component: _0a2e20a0,
      name: "vip-rights-intro-first-pay"
    }, {
      path: "more",
      component: _2e65f5d0,
      name: "vip-rights-intro-more"
    }, {
      path: "vip-package",
      component: _1a8f4a6b,
      name: "vip-rights-intro-vip-package"
    }]
  }, {
    path: "/wd-client/qr-pay",
    component: _62d229c0,
    name: "wd-client-qr-pay"
  }, {
    path: "/",
    component: _475321fc,
    name: "index"
  }, {
    path: "/game-offical/:game_id",
    component: _7f002db2,
    name: "game-offical-game_id"
  }, {
    path: "/gifts/:gift_id",
    component: _4ff0ae17,
    name: "gifts-gift_id"
  }, {
    path: "/game-offical/:game_id?/gift",
    component: _06a96f80,
    name: "game-offical-game_id-gift"
  }, {
    path: "/game-offical/:game_id?/play",
    component: _4404ef84,
    name: "game-offical-game_id-play"
  }, {
    path: "/game-offical/:game_id?/server-list",
    component: _25a628c8,
    name: "game-offical-game_id-server-list"
  }, {
    path: "/game-offical/:game_id?/server-list-update",
    component: _aa1202c4,
    name: "game-offical-game_id-server-list-update"
  }, {
    path: "/game-offical/:game_id?/notice/list",
    component: _470c56d5,
    name: "game-offical-game_id-notice-list"
  }, {
    path: "/game-offical/:game_id?/notice/:notice_id",
    component: _f7a4624c,
    name: "game-offical-game_id-notice-notice_id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
